import { Link } from "@inertiajs/react"
import type { PropsWithChildren } from "react"

import { Button } from "@/components/ui/button"
import { rootPath, signInPath, signUpPath } from "@/routes"

interface AuthLayoutProps {
  name?: string
  title?: string
  description?: string
}

export default function AuthSimpleLayout({
  children,
  title,
  description,
}: PropsWithChildren<AuthLayoutProps>) {
  return (
    <div className="bg-background flex min-h-svh flex-col">
      {/* Guest top nav */}
      <header className="flex items-center justify-between px-6 py-4">
        <Link href={rootPath()} className="flex items-center">
          <img
            src="/images/krown_logo_header.png"
            alt="KrownFT"
            className="h-8"
          />
        </Link>
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            className="text-white hover:bg-white/5"
            asChild
          >
            <Link href={signInPath()}>Iniciar sesión</Link>
          </Button>
          <Button variant="cta" asChild>
            <Link href={signUpPath()}>Registrarse</Link>
          </Button>
        </div>
      </header>

      {/* Auth card */}
      <div className="flex flex-1 flex-col items-center justify-center gap-6 p-6 md:p-10">
        <div className="w-full max-w-sm">
          <div className="flex flex-col gap-8">
            <div className="flex flex-col items-center gap-4">
              <div className="space-y-2 text-center">
                <h1 className="text-xl font-bold tracking-wide text-white">
                  {title}
                </h1>
                <p className="text-muted-foreground text-center text-sm">
                  {description}
                </p>
              </div>
            </div>
            <div className="border-border/50 bg-background/80 rounded-lg border p-6 backdrop-blur-sm">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
